
/* injects from baggage-loader */

'use strict';

export default class RaiseFundsController {

	constructor($log, $timeout, $state, $document, Alerts, Countries, Parse, ProjectSubmission) {
		'ngInject';

		this.$log = $log;
		this.$timeout = $timeout;
		this.$state = $state;
		this.$document = $document;
		this.Alerts = Alerts;
		this.Parse = Parse;
		this.ProjectSubmission = ProjectSubmission;
	

		// Set countries filtered to only the US and Canada
		this.countries = Countries.filter(country => ['US', 'CA'].includes(country.code));

		this.dateOpts = {
			altInput: true,
			altFormat: "F j, Y",
			dateFormat: "Y-m-d",
			onChange: function (selectedDates, dateStr, instance) {
				// Do stuff on change
			}
		};

		this.project = {
			title: '',
			sections: [{
				title: 'About The Raise',
				body: '',
				order: 0,
				default: true
			}, {
				title: 'About The Owner',
				body: '',
				order: 1,
				default: false
			}, {
				title: 'About The Neighborhood',
				body: '',
				order: 2,
				default: false
			}],
			allow_pledge_rewards: false,
			rewards: [{
				title: 'Reward 1',
				amount: '1',
				description: ''
			}]
		}

		// Placeholders
		this.selectedSection = {};
		this.selectedReward = {};

		this.submittingProject = false;

	}

	$onInit() {

		// Select the first section
		this.selectInfoSection(this.project.sections[0]);
		this.selectPledgeReward(this.project.rewards[0]);

		// Load test info
		// this.project.title = 'My First Raise';
		// this.project.description = 'This is my first project, please consider donating.';
		// this.project.city = 'Buffalo';
		// this.project.country = 'US';
		// this.project.postal_code = '14227';
		// this.project.investment_goal_min = '1000';

		this.form_initialized = true;
	}

	datePostSetup(fpItem) {
		// this.$log.log('flatpickr', fpItem);
	}

	newInfoSection() {

		this.project.sections.push({
			title: `Section ${this.project.sections.length + 1}`,
			body: ''
		});

		// Select the new section
		this.selectInfoSection(this.project.sections[this.project.sections.length - 1]);

	}

	selectInfoSection(section) {
		this.project.sections.forEach(s => s.selected = false);
		section.selected = true;
		this.selectedSection = section;
	}

	removeInfoSection() {
		let index = this.project.sections.indexOf(this.selectedSection);
		this.project.sections.splice(index, 1);

		// Select the next section in line
		if (typeof this.project.sections[index] !== 'undefined') {
			this.selectInfoSection(this.project.sections[index]);
		} else {
			this.selectInfoSection(this.project.sections[this.project.sections.length - 1]);
		}
	}

	newPledgeReward() {

		this.project.rewards.push({
			title: `Reward ${this.project.rewards.length + 1}`,
			amount: '1',
			description: ''
		});

		// Select the new reward
		this.selectPledgeReward(this.project.rewards[this.project.rewards.length - 1]);

	}

	selectPledgeReward(reward) {
		this.project.rewards.forEach(s => s.selected = false);
		reward.selected = true;
		this.selectedReward = reward;
	}

	removePledgeReward() {
		let index = this.project.rewards.indexOf(this.selectedReward);
		this.project.rewards.splice(index, 1);

		// Select the next rewards in line
		if (typeof this.project.rewards[index] !== 'undefined') {
			this.selectPledgeReward(this.project.rewards[index]);
		} else  {
			this.selectPledgeReward(this.project.rewards[this.project.rewards.length - 1]);
		}
	}

	async processHeaderMedia(file) {

		// Create a new file reader
		let reader = new FileReader();

		reader.addEventListener('load', () => {
			this.projectMediaPreview = reader.result;
			this.$timeout(() => { /* empty */ }, 100);
		}, false);

		if (file) {
			reader.readAsDataURL(file);
		}

	}

	getHeaderMediaPreview() {
		if (this.projectMediaPreview) {
			return `{'background-image':'url(${this.projectMediaPreview})'}`;
		}
	}
	hasHeaderMediaPreview() {
		return this.projectMediaPreview ? true : false;
	}

	async submitProject() {

		this.submittingProject = true;

		// Copy the project object for manipulation
		let data = JSON.parse(JSON.stringify(this.project));
		// this.$log.log(data);

		// Set the header media
		data.header_media = this.projectHeaderMedia;

		// Submit the project though the submission service
		this.ProjectSubmission.submit(data)
			.then(res => {
				// this.$log.log('Raise Submitted');
				// this.submittingProject = false;
				// this.$timeout();
				this.$state.go('raise-submitted-confirmation')
			})
			.catch(err => {
				// this.$log.error(err);
				
				this.submittingProject = false;
				this.$timeout();

				err = err.toString().replace('ParseError: 141', '').trim();

				this.Alerts.setLocal({
					type: 'danger',
					msg: err
				});

				this.$document.scrollTopAnimated(0);

			});

	}
}



// WEBPACK FOOTER //
// ./src/app/pages/raise-funds/raise-funds.controller.js